import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProductListComponent } from './product-list.component';
import { ProductService } from './products.service';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { ProductDetailComponent } from './product-detail.component';
import { OrderService } from '../onlineorder/order.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    NgxSpinnerModule,
    TranslateModule,
    RouterModule.forChild([
      { path: 'shop/from/:id', component: ProductListComponent },
      { path: 'detail/from/:id:prodId', component: ProductDetailComponent }
    ])
  ],
  declarations: [
    ProductListComponent,
    ProductDetailComponent
  ],
  providers: [
    ProductService,
    OnlineOrderService,
    OrderService
  ]
})
export class ProductModule { }
